import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtService } from 'src/auth/services/jwt.service';
import { Portal } from 'src/shared/constants';
import { UserPolicyEvalDto } from 'src/shared/services/api.service';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';
import { RouteTypeService } from 'src/shared/services/route-type.service';

@Component({
  selector: 'cert-home',
  templateUrl: './home.component.html',
  standalone: false,
})
export class HomeComponent implements OnInit {
  currentAllowedPortals = signal<string[]>([]);
  policySet!: UserPolicyEvalDto;
  userName!: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly jwtService: JwtService,
    private readonly router: Router,
    private readonly routeTypeService: RouteTypeService,
    private readonly featureManager: FeatureManagementService,
  ) {
    this.policySet = this.route.snapshot.data.policySet;
  }

  ngOnInit() {
    this.jwtService.allowedPortals$.subscribe((x) => this.currentAllowedPortals.set(x));
  }

  hasCertPortalAccess(): boolean {
    return this.currentAllowedPortals().some((type) => type.toLowerCase() === Portal.Cert);
  }

  hasLeaPortalAccess(): boolean {
    return this.currentAllowedPortals().some((type) => type.toLowerCase() === Portal.Lea);
  }

  hasEppPortalAccess(): boolean {
    return this.currentAllowedPortals().some((type) => type.toLowerCase() === Portal.Epp);
  }

  hasLea2PortalAccess(): boolean {
    return this.currentAllowedPortals().some((type) => type.toLowerCase() === Portal.Lea2);
  }

  navigateToCertHome() {
    this.router.navigateByUrl(this.routeTypeService.certHomeRoute, { replaceUrl: true });
  }

  navigateToLeaHome() {
    this.router.navigateByUrl(this.routeTypeService.leaHomeRoute);
  }

  navigateToLea2Home() {
    this.router.navigateByUrl(this.routeTypeService.lea2HomeRoute, { replaceUrl: true });
  }

  navigateToEppHome() {
    this.router.navigateByUrl(this.routeTypeService.eppHomeRoute, { replaceUrl: true });
  }
}
